import type {ColorOptions} from './types';

export const colorOptions: Record<string, ColorOptions> = {
    light: {
        lightness: [55, 60],
        chroma: [20, 25],
    },
    dark: {
        lightness: [75, 80],
        chroma: [12, 17],
    },
};

export const textColorVarName = '--g-color-text-inverted-primary';
